module.exports = __webpack_public_path__ + "static/media/add_dept_icon.230c5002.svg";